// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"109":"383ff6de","663":"585877c0"}[chunkId] + ".chunk.css";
};